import { AssetPopularDestinationsBase } from './asset-popular-destinations.base';

export const AssetPopularDestinations = {
  ...AssetPopularDestinationsBase,
  FLIGHTS: [],
  HOTELS: [],
  AUTOS: [],
  BUSES: [],
  PACKAGES: [],
  BYHOURS: [],
  TOUR_AND_ACTIVITIES: [
    'CUZ', 'LIM', 'AQP', 'P1N', 'IQT', 'ICA'
  ],
};
